import Vue from 'vue'
import Router from 'vue-router'
// import model from '@/views/CNBMRE/cnbm-retained-report.vue'
// import model from '@/views/CNBM/cnbm-personal-report.vue'
import model from '@/views/CNBMTalent/cnbm-personal-report.vue'
import cccst from '@/views/CCCST/cccst-personal-report'
Vue.use(Router)
import '@/styles/index.scss'

export default new Router({
  routes: [
    {
      path: '/',   //替换打包📦
      component: model
    },
    {
      path: '/cccst',
      component: cccst//替换打包📦
    },

    { path: '*', redirect: '/home', hidden: true },
  ],
  mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js